<template>
  <div
    class="Management-guide-content-item-main"
    :class="{ 'Management-guide-content-item-main-mobile': isMobile }"
  >
    <div class="title">产品隐私管理指南</div>
    <div class="names">
      <span
        v-for="item in data[0].guide"
        :key="item.productName"
        @click="changeUrl(item)"
        :style="{ color: title === item.title ? '#4db0ff' : '' }"
        >{{ item.title }}
      </span>
    </div>
    <div class="circle" :style="{ backgroundImage: `url(${url})` }"></div>
  </div>
</template>
<script>
export default {
  name: "ManagementGuideContentItem",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: require("../../assets/images/privacyManage/iphone1.png"),
      title: "1",
      list: [],
    };
  },
  methods: {
    changeUrl(item) {
      this.title = item.title;
      this.url = item.pic;
    },
  },
  async created() {
    this.readDictByKey("privacyAdminGuide", (res) => {
      this.list = res.list.item;
      let list = res.list.item.filter(
        (a) => a.productName === this.$store.state.app.type
      );
      this.url = list.length ? list[0].guide[0].pic : "";
      this.title = list.length ? list[0].guide[0].title : "";
    });
  },
  computed: {
    types() {
      return this.$store.state.app.type;
    },
  },
  watch: {
    types: {
      deep: true,
      handler(newValue, oldValue) {
        this.url = this.list.filter((a) => a.productName === newValue)[0].guide[0].pic;
        this.title = this.list.filter(
          (a) => a.productName === newValue
        )[0].guide[0].title;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.Management-guide-content-item-main {
  margin-bottom: calc($multiple * 56px);
  position: relative;
  .title {
    font-size: calc($multiple * 24px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: calc($multiple * 33px);
    letter-spacing: calc($multiple * 1px);
  }
  .names {
    font-size: calc($multiple * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.57);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
    padding-left: calc($multiple * 15px);
    margin-top: calc($multiple * 20px);
    span {
      line-height: calc($multiple * 43px);
      cursor: pointer;
      font-size: calc($multiple * 16px);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.57);
      line-height: calc($multiple * 43px);
    }
    span:last-child {
      margin-bottom: 0;
    }
  }
  .names::before {
    content: "";
    position: absolute;
    top: 13px;
    left: 0;
    width: calc($multiple * 5px);
    height: 90%;
    background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
    border-radius: calc($multiple * 1px);
  }
  .circle {
    position: absolute;
    top: calc($multiple * -50px);
    /* left: calc($multiple * 530px); */
    right: 0;
    width: calc($multiple * 733px);
    height: calc($multiple * 613px);
    /* width: calc($multiple * 415px); */
    /* height: calc($multiple * 829px); */
    background-repeat: no-repeat;
    /* background: url('~assets/images/privacyManage/iphone1.png') no-repeat; */
    background-size: 100%;
  }
}
.Management-guide-content-item-main-mobile {
  margin-bottom: 0;
  width: 100%;
  .title {
    font-size: 0.83rem;
    line-height: 1.13rem;
    letter-spacing: 0.03rem;
  }
  .names {
    font-size: 0.61rem;
    color: #8b8b8b;
    height: 3.34rem;
    line-height: 0.98rem;
    padding-left: 0.36rem;
    margin-top: 1.08rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    span {
      margin-bottom: 0.1rem;
      line-height: 1rem;
    }
    span:last-child {
      margin-bottom: 0;
    }
    &::before {
      width: 0.1rem;
      height: 90%;
      top: 0;
      background: linear-gradient(180deg, #4db0ff 0%, #81aaff 100%);
      border-radius: 0.05rem;
    }
  }
  .circle {
    position: relative;
    top: 1.24rem;
    left: 1rem;
    bottom: 0;
    width: 15.2rem;
    height: 12rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
</style>
